if (!customElements.get('video-responsive')) {
  customElements.define(
    'video-responsive',
    class VideoResponsive extends HTMLElement {
      constructor() {
        super();
        this.videoEl = this.querySelector('video');
        this.mediaQuery = this.getAttribute('media-query');

        if (!this.videoEl || !this.mediaQuery) {
          return;
        }

        this.handleMediaChange = this.handleMediaChange.bind(this);
        this.handleIntersection = this.handleIntersection.bind(this);
        this.init = this.init.bind(this);

        this.mediaQueryList =
          typeof window.matchMedia === 'function'
            ? window.matchMedia(this.mediaQuery)
            : null;
      }

      connectedCallback() {
        if (!this.videoEl || !this.mediaQuery) {
          return;
        }

        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', this.init, { once: true });
        } else {
          this.init();
        }
      }

      disconnectedCallback() {
        this.detachMediaListener();
        this.disconnectObserver();
      }

      init() {
        if (this.hasAttribute('loaded')) {
          return;
        }

        if (!this.mediaQueryList) {
          this.load(true);
          return;
        }

        if (this.mediaQueryList.matches) {
          this.load();
        } else {
          this.attachMediaListener();
        }
      }

      attachMediaListener() {
        if (!this.mediaQueryList) {
          return;
        }

        if (typeof this.mediaQueryList.addEventListener === 'function') {
          this.mediaQueryList.addEventListener('change', this.handleMediaChange);
        } else if (typeof this.mediaQueryList.addListener === 'function') {
          this.mediaQueryList.addListener(this.handleMediaChange);
        }
      }

      detachMediaListener() {
        if (!this.mediaQueryList) {
          return;
        }

        if (typeof this.mediaQueryList.removeEventListener === 'function') {
          this.mediaQueryList.removeEventListener('change', this.handleMediaChange);
        } else if (typeof this.mediaQueryList.removeListener === 'function') {
          this.mediaQueryList.removeListener(this.handleMediaChange);
        }
      }

      handleMediaChange(event) {
        if (event.matches) {
          this.detachMediaListener();
          this.load();
        }
      }

      handleIntersection(entries) {
        const entry = entries.find((item) => item.isIntersecting);

        if (entry) {
          this.disconnectObserver();
          this.load(true);
        }
      }

      observeVisibility() {
        if (this.hasAttribute('loaded') || this.visibilityObserver) {
          return;
        }

        if (typeof window.IntersectionObserver !== 'function') {
          this.load(true);
          return;
        }

        this.visibilityObserver = new IntersectionObserver(this.handleIntersection, {
          rootMargin: '200px',
        });

        this.visibilityObserver.observe(this.videoEl);
      }

      disconnectObserver() {
        if (this.visibilityObserver) {
          this.visibilityObserver.disconnect();
          this.visibilityObserver = null;
        }
      }

      load(force = false) {
        if (!this.videoEl || this.hasAttribute('loaded')) {
          return;
        }

        if (!force && typeof this.videoEl.checkVisibility === 'function') {
          try {
            if (!this.videoEl.checkVisibility()) {
              this.observeVisibility();
              return;
            }
          } catch (error) {
            this.observeVisibility();
            return;
          }
        }

        const videoSources = this.videoEl.querySelectorAll('source[data-src]');
        videoSources.forEach((videoSource) => {
          videoSource.src = videoSource.dataset.src;
        });

        this.videoEl.load();
        this.setAttribute('loaded', '');
        this.detachMediaListener();
        this.disconnectObserver();
      }
    }
  );
}